export const loaderStyles = `

.viddy-loader {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 100%;
}
.viddy-loader div {
  position: absolute;
  border: 4px solid #fff;
  opacity: 1;
  border-radius: 50%;
  animation: viddy-loader 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.viddy-loader div:nth-of-type(2) {
  animation-delay: -0.5s;
}

@keyframes viddy-loader {
  0% {
    top: 18px;
    left: 18px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 18px;
    left: 18px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 18px;
    left: 18px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 36px;
    height: 36px;
    opacity: 0;
  }
}

`
